import {
  checkRegisterEmailAvailability,
  type RegisterEmailAvailabilityResponse,
} from "@/lib/services/authService";

export async function checkPublicRegisterEmailAvailability(
  email: string
): Promise<RegisterEmailAvailabilityResponse> {
  return checkRegisterEmailAvailability(email);
}
